<template>
  <component
    :is="drawerComponent"
    v-if="drawerComponent"/>
</template>

<script setup>
import { computed } from 'vue'
import { useOverlaysStore } from '@/stores/overlays'
import { storeToRefs } from 'pinia'
import ChatbotDrawer from '@/components/chatbot/ChatbotDrawer.vue'


const drawerMap = {
  chatbot: ChatbotDrawer,
}
const overlays = useOverlaysStore()
const { drawerName } = storeToRefs(overlays)

const drawerComponent = computed(() => {
  return drawerName.value ? drawerMap[drawerName.value] || null : null
})

</script>
